import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import * as MarcaApi from 'api/marca';
import { getResponseError } from 'util/errorHelper';

const MarcaContext = createContext({
  data: [],
  loading: false,
  error: null,
  fetchMarcas: () => {},
});

export const MarcaContextProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMarcas = useCallback(async () => {
    try {
      const { data: response } = await MarcaApi.list();

      if (response && response.length && Array.isArray(response)) {
        setData(response);
      } else {
        setData([]);
      }
    } catch (err) {
      setError(getResponseError(err));
    } finally {
      setLoading(false);
    }
  }, [setData, setLoading, setError]);

  return (
    <MarcaContext.Provider value={{
      data,
      fetchMarcas,
      loading,
      error,
    }}
    >
      {children}
    </MarcaContext.Provider>
  );
};

MarcaContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MarcaContext;
